/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';

import * as angular from 'angular';
import { LegacyRouting } from 'src/app/services/legacy-helpers/legacy-routing.service';

import { analyticsEventsService } from 'src/app/plain-javascript/services/analytics/AnalyticsEventsService';
import { LOCATION_LIST_MUST_BE_UNIQUE } from '@touchplan/strings';

angular.module('ticketspaceApp').factory('firebaseLocations', [
	'$q',
	'$firebaseUtils',
	'$firebaseArray',
	'fbConnection',
	'popup',
	'legacyRouting',
	function ($q, $firebaseUtils, $firebaseArray, fbConnection, popup, legacyRouting: LegacyRouting) {
		function Location(snap) {
			this.$id = snap.key;
			this.local = {};
			this.update(snap);
		}
		Location.prototype = {
			update(snap) {
				//store the data on...data
				let oldData = this.data || {};
				this.data = snap.val();
				//var changed = !angular.equals(this.data, oldData);
				this.prevData = snap.val();
				return true;
			},
			toJSON() {
				//return the parsed data from it's "data" location
				return $firebaseUtils.toJSON(this.data);
			},
		};

		//Array instance section
		function LocationsFactory(ref, locationColors) {
			// call the super constructor
			this.locationColors = locationColors;
			this._usedStyles = this.locationColors.getUsedColors();
			this.colorPalette = this.locationColors.getColorPalette();
			let thing = $firebaseArray.call(this, ref);
			thing._usedStyles = this._usedStyles;
			thing.locationColors = locationColors;
			thing.colorPalette = this.colorPalette;
			return thing;
		}
		LocationsFactory.prototype = {
			$$added(snap) {
				let style = snap.child('locationColor').val();
				$firebaseArray.prototype.$$added.call(this, snap);
				let t = new Location(snap);
				t.$parent = this.$list;
				this.locationColors.updateUsedColors('add', style);
				return t;
			},
			$$updated(snap) {
				let t = this.$getRecord(snap.key);
				let colorId = snap.child('locationColor').val();
				let color = this.locationColors.$getRecord(colorId);
				let oldColor = this.locationColors.$getRecord(t.prevData.locationColor);
				if (color && oldColor) {
					this.locationColors.updateUsedColors('change', color.data.color, oldColor.data.color);
				} else {
					// MOC-2489
					this.locationColors.updateUsedColors('add', colorId);
				}
				t.update(snap);
			},
			$$removed(snap) {
				let t = this.$getRecord(snap.key);
				let style = snap.child('locationColor').val();
				t.$parent = null;
				this.locationColors.updateUsedColors('remove', style);
				return t;
			},
			$add(data) {
				if (!data || !data.name || !data.locationColor) {
					return $q.rejectErr('name and style is required');
				}
				return $firebaseArray.prototype.$add.apply(this, arguments).then(function (ref) {
					analyticsEventsService.createdALocation(
						ref.key,
						legacyRouting.oldStyleSnapshot().planId,
						data.name,
						data.locationColor
					);
					return ref;
				});
			},
			$remove(idx) {
				if (this.$list[idx]) {
					let rec = this.$list[idx];
					analyticsEventsService.deletedALocation(
						rec.$id,
						legacyRouting.oldStyleSnapshot().planId,
						rec.data.name
					);
				}
				return $firebaseArray.prototype.$remove.apply(this, arguments);
			},
			confirmRemove(idx) {
				let self = this;
				let args = arguments;
				return popup({ title: 'Are you sure you want to delete this location?' }).then(function () {
					return self.$remove.apply(self, args);
				});
			},
			$childRef(childId) {
				return this.$ref().child(childId).ref;
			},
			isLocationNameExist(locationName, idx) {
				const newLocationLowerCased: string = locationName.toLowerCase();
				for (let i = 0; i < this.$list.length; i++) {
					const location = this.$list[i];
					const existingLocationLowerCased: string = location.data.name
						? location.data.name.toLowerCase()
						: '';
					if (existingLocationLowerCased === newLocationLowerCased && i !== idx) {
						return true;
					}
				}
				return false;
			},
			editableListAdd(data) {
				if (!data || !data.name || !data.locationColor) {
					return $q.rejectErr('Location must have a name and color!');
				}
				if (this.isLocationNameExist(data.name, -1)) {
					return $q.rejectErr(LOCATION_LIST_MUST_BE_UNIQUE);
				}
				let self = this;
				return this.locationColors
					.handleAddColor(data.locationColor)
					.then(function (record) {
						data.locationColor = record.$id;
						return self.$list.$add.call(self.$list, data);
					})
					.then(function (snap) {
						return snap;
					});
			},
			set(idx, data) {
				let self = this;
				let item = this.$list[idx];
				if (!item) {
					return $q.rejectErr("item doesn't exist");
				}
				if (!data || !data.name || !data.locationColor) {
					return $q.rejectErr('Location name and color is required');
				}
				if (this.isLocationNameExist(data.name, idx)) {
					return $q.rejectErr(LOCATION_LIST_MUST_BE_UNIQUE);
				}
				item.data.name = data.name;
				let color = data.locationColor;
				let newRec = this.locationColors.getRecordByColor(color);
				item.data.locationColor = newRec.$id;
				return self.$save(idx);
			},
			nextStyle,
			cloneForEdit,
		};
		let theFactory = $firebaseArray.$extend(LocationsFactory);

		function nextStyle() {
			return this.locationColors.getFirstUnusedColor();
		}

		function cloneForEdit(index, collection) {
			if (index === -1) {
				return { locationColor: collection.nextStyle() };
			}
			if (index !== -1 && collection[index] !== undefined) {
				let obj = angular.extend({}, collection[index].data);
				if (obj.locationColor) {
					obj.locationColor = this.locationColors.getColor(obj.locationColor);
				}
				return obj;
			}
			return {};
		}

		function returnFunction(refUrl, locationColors) {
			return new theFactory(refUrl, locationColors);
		}
		//add properties to the returnFunction for static code

		return returnFunction;
	},
]);
